import { Mutation, QueryResourceArgs } from '../__generated__/graphql';

import DELETE_RESOURCE from '../graphql/deleteResource';
import RemoveHookData from './@types/RemoveHookData';
import { closeRemoveModal } from '../redux/actions/modals.actions';
import { flashApolloError } from '../util/errorUtils';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';

type DeleteResourceData = Pick<Mutation, 'deleteOneResource'>;

export default function useRemoveResource(): RemoveHookData {
  const dispatch = useDispatch();
  const history = useHistory();

  const [remove, { error, loading }] = useMutation<DeleteResourceData, QueryResourceArgs>(
    DELETE_RESOURCE,
    {
      onCompleted: ({ deleteOneResource }) => {
        dispatch(closeRemoveModal());

        if (deleteOneResource) {
          window.flash({
            message: `Resource: ${deleteOneResource.name} removed successfully`,
          });
        } else {
          window.flash({ message: 'Fail to remove resource' });
        }

        history.go(0);
      },
      onError: flashApolloError,
    }
  );

  return {
    error,
    loading,
    mutation: (id: string): void => {
      remove({
        variables: {
          where: { id },
        },
      });
    },
  };
}
